import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { PlusCircleIcon } from "lucide-react";
import { readUsersUsersGet } from "@/client-admin";
import { buttonVariants } from "@/components/ui/button";
import { columns } from "@/components/admin/UserTable/columns";
import { DataTable } from "@/components/admin/UserTable/data-table";
import { LoadingComponent } from "@/components/LoadingComponent";
import { checkSuperUserPermission } from "@/lib/utils";

export const Route = createFileRoute("/_superuser/admin/users/")({
  component: UsersPage,
  beforeLoad: () => {
    try {
      checkSuperUserPermission("user-management");
    } catch (error) {
      console.error(error);
      throw redirect({ to: "/403" });
    }
  },
});

function UsersPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["users"],
    queryFn: () => readUsersUsersGet(),
  });

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (isLoading || !data) {
    return <LoadingComponent />;
  }

  return (
    <div className="grid grid-cols-1 gap-2">
      <div className="flex justify-center">
        <Link className={buttonVariants()} to={"/admin/users/new"}>
          <PlusCircleIcon />
          Create User
        </Link>
      </div>

      <DataTable data={data.data} columns={columns} />
    </div>
  );
}
